import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import {
  UserEntityPermission,
  UserEntityPermissionsNames,
} from 'types/embedded/userEntityPermission';

export const getUserEntityPermissions = async (filter: {
  entity: UserEntityPermissionsNames;
  rowId: number;
}): Promise<UserEntityPermission[]> => {
  const params = qs.stringify(
    {
      ...filter,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`user_entity_permissions?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const deleteUserEntityPermissions = async (id: number): Promise<AxiosResponse> => {
  return axios
    .delete(`user_entity_permissions/${id}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
